import { render } from "./Contactform.vue?vue&type=template&id=977613fa&scoped=true&ts=true"
import script from "./Contactform.ts?vue&type=script&lang=ts"
export * from "./Contactform.ts?vue&type=script&lang=ts"

import "./Contactform.scss?vue&type=style&index=0&id=977613fa&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-977613fa"]])

export default __exports__